<template>
  <div>
    <h1 class="logintitle">
      <img src="../../assets/interview/images/icon-logo.png" alt="">
    </h1>
    <div class="loginbox">
      <div class="left">
        <h2 class="content-title">日本院校云面试系统</h2>
        <h3 class="content-title2">Japan Language School  Interview System</h3>
        <form method="post" @submit.stop.prevent="submit">
          <ul>
            <li class="input-icon">
              <div>
                <input class="login-input" v-model.trim="username" @input="clearErrMsg" name="username" autocomplete="off" type="text" placeholder="请输入账户/用户名">
              </div>
              <span v-show="invalidUsername">{{ errorMsg }}</span>
            </li>
            <li class="input-icon icon-pwd">
              <div>
                <input class="login-input" v-model.trim="password" @input="clearErrMsg" name="password" autocomplete="off" type="password" placeholder="请输入密码">
              </div>
              <span v-show="invalidPassword">您输入的密码有误</span>
            </li>
            <li>
              <button class="login-btn" type="submit">登录</button>
            </li>
          </ul>
        </form>
      </div>
      <div class="right">
        <img src="../../assets/interview/images/img-login.png" alt="">
      </div>
    </div>
    <div class="loginbm">
      <!-- <h4>星图考培信息系统</h4> -->
      <!-- <p>Star Map exam&training Information System</p> -->
      <p><a href="https://interview.jiemo.net">interview.jiemo.net</a> Copyright © {{ year }} Qing Yun. All Rights Reserved</p>
    </div>
  </div>
</template>
<script>
import { _post } from '@/utils/http';
import lockr from 'lockr';

export default {
  name: 'Login',
  data() {
    return {
      invalidUsername: false,
      invalidPassword: false,
      username: '',
      password: '',
      errorMsg: '',
    };
  },
  computed: {
    year() {
      return (new Date()).getFullYear();
    }
  },
  methods: {
    clearErrMsg() {
      this.invalidUsername = false;
    },
    submit() {
      if (!this.username) {
        this.invalidUsername = true;
        this.errorMsg = '用户名不能为空!';
        return false;
      }
      _post({
        url: '/index/login/index',
        data: {
          username: this.username,
          password: this.password
        }
      }).then((res) => {
        if (res.code > 0) {
          this.errorMsg = res.msg;
          this.invalidUsername = true;
          return false;
        }
        lockr.set('jwt', res.data);
        window.location.href = '/';
      });
      return false;
    }
  },
  beforeCreate() {
    lockr.set('jwt', null);
  }
};
</script>
<style>
  body {
    height: 100%;
    background:#eaf0f4 url('../../assets/interview/images/login_bg.jpg');
    background-size: cover;
    background-position: top center;
    background-repeat: no-repeat;
    overflow: hidden;
  }
  #app {
    padding-top: 130px;
    height:100%;
    background: none;
  }
</style>
<style scoped>

h1 {
  padding-top: 10px!important;
  font-size: 18px;
}
.login-input {
  border: none;
  width: 310px;
  height: 50px;
  border: none;
  line-height: 50px;
  font-size: 15px;
  outline: none;
  color: #333 !important;
  font-family: "微软雅黑", Microsoft Yahei;
  padding: 0 10px 0 0;
}
.input-icon > div{
  margin-bottom:17px;
  /*background: url(../../assets/interview/images/icon-user.png) no-repeat 20px center !important;*/
}
.icon-pwd > div{
  /*background: url(../../assets/interview/images/icon-pasword.png) no-repeat 20px center !important;*/
}
.login-btn {
  background-color: #5eb2c7;
  cursor: pointer;
  color: #FFF !important;
  height: 55px;
  line-height: 55px;
  width: 100%;
  border: none;
  margin-top: 40px;
  font-size: 20px;
  box-shadow: 0 15px 39px rgba(94,178,199,.59);
  transition: all linear 0.2s;
}
.login-btn:hover{
  box-shadow: 0 15px 59px rgba(94,178,199,.59);
}
.logintitle {
  text-align: center;
  color: #fff;
  font-weight: bold;
  font-size: 36px;
  margin-bottom: 40px;
  animation: wobble-vertical 10s linear infinite;
  position: absolute;
  left: 16.6%;
  top:3.8%;
}
.loginbox {
  background: #fff;
  width: 1000px;
  height:600px;
  margin: auto;
  text-align: center;
  padding-bottom: 30px;
  animation: loginmove 1s ease-out 1;
  -webkit-border-radius: 25px; -moz-border-radius: 25px; border-radius: 25px;
  box-shadow: 0 0 27px 5px rgba(13,75,90,.27);
  margin-top: 50px;
  overflow: hidden;
}
.loginbox .left{
  width: 50%;
  float: left;
}
.loginbox .right{
  width: 50%;
  float: right;
}
.loginbox .right img{
  width: 100%;
}
.loginbox .content-title{
  font-size: 28px;
  line-height:40px;
  padding: 100px 0 18px;
  font-weight: normal;
  color: #4a4b4b;
}
.loginbox .content-title2{
  font-size: 18px;
  color: #929393;
  font-weight: normal;
  padding-bottom: 50px;
}

.loginbox ul li {
  position: relative;
  display: block;
  width: 384px;
  margin: auto;
  padding: 5px 0;

}
.loginbox ul li > div{
  border: 2px solid #e7e7e7;
}
.loginbox ul li span {
  position: absolute;
  right: -200px;
  top: 5.5px;
  display: block;
  width: 211px;
  height: 52px;
  text-align: center;
  line-height: 52px;
  background-color: #fcd71d;
  font-size: 18px;
  color: #383838;
}
.loginbox ul li i{
  font-size: 16px;
  color: #9b9b9b;
  line-height: 22px;
  display: block;
  text-align: left;
}
.loginbox ul li span:before {
  display: block;
  content: "";
  position: absolute;
  left: -10px;
  top: 50%;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 10px solid #fcd71d;
  border-left: none;
  margin-top: -10px;
}

.loginbm {
  line-height: 23px;
  text-align: center;
  padding-top: 30px;
  width: 100%;
  color: #fff;
  animation: loginmove 2s ease-out 1;
}
.loginbm h4 {
  color: #fff;
  font-size: 14px;
  font-weight: 200;
}
.loginbm p {
  color: #fff;
  font-size: 12px;
  padding: 0;
  margin: 0;
  opacity: 0.8;
}

.loginbm a {
  font-weight: bold;
  color: #fff;
}

.loginbm a:hover {
  color: #fff;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus textarea:-webkit-autofill,
textarea:-webkit-autofill:hover textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  -webkit-text-fill-color: #333;
  transition: background-color 50000s ease-in-out 0s;
}
@-webkit-keyframes wobble-vertical {
  0% {
    -webkit-transform: translateY(0px);
    transform: translateY(0px);
  }
  25% {
    -webkit-transform: translateY(8px);
    transform: translateY(8px);
  }
  50% {
    -webkit-transform: translateY(-8px);
    transform: translateY(-8px);
  }
  75% {
    -webkit-transform: translateY(8px);
    transform: translateY(8px);
  }
  100% {
    -webkit-transform: translateY(0px);
    transform: translateY(0px);
  }
}

@keyframes wobble-vertical {
  0% {
    -webkit-transform: translateY(0px);
    -ms-transform: translateY(0px);
    transform: translateY(0px);
  }
  25% {
    -webkit-transform: translateY(8px);
    -ms-transform: translateY(8px);
    transform: translateY(8px);
  }
  50% {
    -webkit-transform: translateY(-8px);
    -ms-transform: translateY(-8px);
    transform: translateY(-8px);
  }
  75% {
    -webkit-transform: translateY(8px);
    -ms-transform: translateY(8px);
    transform: translateY(8px);
  }
  100% {
    -webkit-transform: translateY(0px);
    -ms-transform: translateY(0px);
    transform: translateY(0px);
  }
}
@keyframes loginmove {
  0% {
    opacity: 0;
    -webkit-transform: translateY(50px);
    -ms-transform: translateY(50px);
    transform: translateY(50px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translateY(0);
    -ms-transform: translateY(0);
    transform: translateY(0);
  }
}

</style>
